module.exports = __webpack_public_path__ + "img/icon211.bd77e500.png";